// src/services/userDocumentServices.ts
import api from "../lib/api.ts";

export const getUserDocumentTypes = async (userType: string, userTypeId: number) => {
  if (userType === "buyer") {
    const response = await api.get(`/userdocumenttypes/buyer/${userTypeId}`);
    return response.data;
  } else if (userType === "seller") {
    const response = await api.get(`/userdocumenttypes/seller/${userTypeId}`);
    return response.data;
  }
};
export const createUserDocument = async (
  userType: string,
  documentData: any
) => {
  if (userType === "buyer") {
    const response = await api.post("/buyerdocuments", documentData);
    return response.data;
  } else if (userType === "seller") {
    const response = await api.post("/sellerdocuments", documentData);
    return response.data;
  }
};

export const getUserDocuments = async (userType: string, userId: number) => {
  if (userType === "buyer") {
    const response = await api.get(`/buyerdocuments/buyer/${userId}`);
    return response.data;
  } else if (userType === "seller") {
    const response = await api.get(`/sellerdocuments/seller/${userId}`);
    return response.data;
  }
};
// http://3.28.71.76:5000/api/userdocumenttypes/buyer/1

export const deleteUserDocument = async (userType: string, id: number) => {
  if (userType === "buyer") {
    const response = await api.delete(`/buyerdocuments/${id}`);
    return response.data;
  } else if (userType === "seller") {
    const response = await api.delete(`/sellerdocuments/${id}`);
    return response.data;
  }
};
